export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "app/js/app.worker.98299060c19a7064259e.1793684650243.worker.js");
}
